export const iconFontAwesomePoliticalPersonBooth = (
	<i className="fa-solid fa-person-booth"></i>
);
